import PadraoModel from 'src/core/model/PadraoModel.js'

export default class WebmotorsAcessorioModel extends PadraoModel {
  recurso = 'webmotors/acessorios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Acessórios Webmotors';

  colunasGrid = [
  ];

  form = {
    CodigoOpcional: null,
    Descricao: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
